var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87239 7.08654L6.49998 7.58605V10.2441H4.99998V6.53164H5.01125L8.96255 5.09349C9.14555 5.02305 9.34415 4.98786 9.5486 4.99474C10.3821 5.01524 11.1141 5.56165 11.3688 6.35941C11.5085 6.79737 11.636 7.09291 11.7511 7.24602C12.4353 8.15577 13.524 8.74414 14.75 8.74414V10.2441C13.119 10.2441 11.6617 9.50037 10.6988 8.33359L10.1756 11.3005L11.75 12.6216V17.7441H10.25V13.321L8.54802 11.8929L8.00225 14.9881L2.83203 14.0765L3.0925 12.5992L6.78553 13.2504L7.87239 7.08654ZM10.625 4.61914C9.79655 4.61914 9.125 3.94757 9.125 3.11914C9.125 2.29071 9.79655 1.61914 10.625 1.61914C11.4534 1.61914 12.125 2.29071 12.125 3.11914C12.125 3.94757 11.4534 4.61914 10.625 4.61914Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunLine);
export default __webpack_public_path__ + "static/media/run-line.33065ff24e7af8704e8a3c66f64a5ab8.svg";
export { ForwardRef as ReactComponent };